import { render, staticRenderFns } from "./ContentsEdit.vue?vue&type=template&id=6589522a&scoped=true&"
import script from "./ContentsEdit.vue?vue&type=script&lang=js&"
export * from "./ContentsEdit.vue?vue&type=script&lang=js&"
import style0 from "./ContentsEdit.vue?vue&type=style&index=0&id=6589522a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6589522a",
  null
  
)

export default component.exports